import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';
import AddComplimentrySubscription from './addComplimentrySubscription';

const Users = React.lazy(() => import('./index'));
const UserTable = React.lazy(() => import('./userTable'));
const User = React.lazy(() => import('./user'));
const UserDetail = React.lazy(() => import('./userDetail'));
const AddNewUser = React.lazy(() => import('./addNewUser'));
const PoliciesEditor = React.lazy(() => import('./policiesEditor'));
const EditUser = React.lazy(() => import('./editUser'));

export const useUserRoutes = () => {

    return (
        <Route path="users" element={<Suspense fallback={<div>منتظر باشید...</div>}><Users /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><UserTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewUser/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><User/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><UserDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditUser/></Suspense> } />
                <Route path="userPolicies" element={<Suspense fallback={<div>منتظر باشید...</div>}><PoliciesEditor/></Suspense> } />
                <Route path="complimentrySubscription" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddComplimentrySubscription/></Suspense> } />
            </Route>
        </Route>
    )
}